export default [
    {
        path: '/errors-log/',
        component: () => import('../components/ErrorsLog.vue'),
        name: 'errors-log',
        meta: {},
    },

]